import script from "./Publicity.vue?vue&type=script&setup=true&lang=ts"
export * from "./Publicity.vue?vue&type=script&setup=true&lang=ts"

import "./Publicity.vue?vue&type=style&index=0&id=30c02150&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30c02150"]])

export default __exports__